import { Controller } from "stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  connect() {
    if (this.element.value) {
      const number = parseFloat(String(this.element.value).replace(/,/g, ""))
      if (!isNaN(number)) {
        this.element.value = number.toFixed(2)
      }
    }

    Inputmask({
      alias: "currency",
      prefix: "",
      groupSeparator: "",
      digits: 2,
      digitsOptional: false,
      rightAlign: false,
      allowMinus: false
    }).mask(this.element)
  }

  disconnect() {
    if (this.element.inputmask) {
      this.element.inputmask.remove()
    }
  }
}
